<template>
  <section
    :id="id"
    class="how_to_sell"
  >
    <div class="osk-wrapper">
      <div class="title_block_sm">
        {{ title }}
      </div>

      <div class="flex_block_sell">
        <div class="left_block_sell">
          <div class="info_all_block">
            <ul>
              <li
                v-for="(step, i) in steps"
                :key="step.title"
              >
                <div class="number">
                  {{ i + 1 }}
                </div>

                <div class="name_block">
                  {{ step.title }}
                </div>

                <p
                  v-for="text in step.description"
                  :key="text"
                >
                  {{ text }}
                </p>
              </li>
            </ul>
          </div>
        </div>

        <!-- TODO: sticky block -->
        <div class="right_block_sell">
          <div class="text_block">
            <div class="icon">
              <UIIcon
                name="safe-deal2"
                width="50"
                height="37"
              />
            </div>

            <p>
              <strong>{{ rightBlockTexts.strong }}</strong>
              {{ rightBlockTexts.text }}
            </p>

            <UikitButton
              full-width
              size="m"
              class="action-button"
              @click="handleClick"
            >
              {{ button.label }}
            </UikitButton>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ANCHORS } from '~/components/info/anchors';
import { PrimaryPageType } from '~/restAPI/data-contracts';

const props = withDefaults(defineProps<{
  type: 'sell' | 'buy'
}>(), {});

const { t } = useI18n();

const sellSteps = [
  {
    title: t('components.info.howTo.sellStep1.title'),
    description: [t('components.info.howTo.sellStep1.description')],
  },
  {
    title: t('components.info.howTo.sellStep2.title'),
    description: [t('components.info.howTo.sellStep2.description')],
  },
  {
    title: t('components.info.howTo.sellStep3.title'),
    description: [t('components.info.howTo.sellStep3.description')],
  },
  {
    title: t('components.info.howTo.sellStep4.title'),
    description: [t('components.info.howTo.sellStep4.description')],
  },
  {
    title: t('components.info.howTo.sellStep5.title'),
    description: [
      t('components.info.howTo.sellStep5.description1'),
      t('components.info.howTo.sellStep5.description2'),
    ],
  },
];
const buySteps = [
  {
    title: t('components.info.howTo.buySteps1.title'),
    description: [t('components.info.howTo.buySteps1.description')],
  },
  {
    title: t('components.info.howTo.buySteps2.title'),
    description: [t('components.info.howTo.buySteps2.description')],
  },
  {
    title: t('components.info.howTo.buySteps3.title'),
    description: [t('components.info.howTo.buySteps3.description')],
  },
  {
    title: t('components.info.howTo.buySteps4.title'),
    description: [t('components.info.howTo.buySteps4.description')],
  },
];

const { account, isAuth, openAuthDialog } = useAccountStore();

const id = {
  buy: ANCHORS.HOW_TO_BUY,
  sell: ANCHORS.HOW_TO_SELL,
}[props.type];
const steps = {
  buy: buySteps,
  sell: sellSteps,
}[props.type];
const title = {
  buy: t('components.info.howTo.title.buy'),
  sell: t('components.info.howTo.title.sell'),
}[props.type];
const rightBlockTexts = {
  buy: {
    strong: t('components.info.howTo.rightBlockTexts.buy.strong'),
    text: t('components.info.howTo.rightBlockTexts.buy.text'),
  },
  sell: {
    strong: t('components.info.howTo.rightBlockTexts.sell.strong'),
    text: t('components.info.howTo.rightBlockTexts.sell.text'),
  },
}[props.type];
const button = {
  buy: {
    label: t('components.info.howTo.button.buy.label'),
  },
  sell: {
    label: t('components.info.howTo.button.sell.label'),
  },
}[props.type];

function handleClick() {
  if (props.type === 'buy') {
    const link = isAuth.value && account.value.sex === PrimaryPageType.MALE ? '/catalog/muzhskoe' : '/catalog/zhenskoe';

    return navigateTo(link);
  }

  if (!isAuth.value) {
    openAuthDialog({
      to: '/publication',
      chapter: 'sale_request',
    });
    return false;
  }

  return navigateTo('/publication');
}
</script>

<style scoped lang="scss">
section.how_to_sell {
  padding: 80px 0;
  border-top: 1px solid rgba(51, 51, 51, 0.1);
}

section.how_to_sell .flex_block_sell {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 42px;
  position: relative;
}

section.how_to_sell .flex_block_sell .left_block_sell {
  width: 540px;
  max-width: calc(100% - 430px);
}

section.how_to_sell .flex_block_sell .left_block_sell .info_all_block ul li {
  position: relative;
  padding: 5px 5px 38px 38px;
}

section.how_to_sell .flex_block_sell .left_block_sell .info_all_block ul li:last-child {
  padding-bottom: 0;
}

section.how_to_sell .flex_block_sell .left_block_sell .info_all_block ul li:last-child:before {
  display: none;
}

section.how_to_sell .flex_block_sell .left_block_sell .info_all_block ul li:before {
  content: "";
  position: absolute;
  top: 0;
  left: 11px;
  background: #27AE60;
  width: 1px;
  height: 100%;
}

section.how_to_sell .flex_block_sell .left_block_sell .info_all_block ul li .number {
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  width: 24px;
  height: 24px;
  line-height: 24px;
  color: #ffffff;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  background: #27AE60;
  border-radius: 50%;
}

section.how_to_sell .flex_block_sell .left_block_sell .info_all_block ul li .name_block {
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
}

section.how_to_sell .flex_block_sell .left_block_sell .info_all_block ul li p {
  color: #828282;
  font-size: 14px;
  line-height: 21px;
  margin-top: 8px;
  margin-bottom: 21px;
}

section.how_to_sell .flex_block_sell .left_block_sell .info_all_block ul li p:last-child {
  margin-bottom: 0;
}

section.how_to_sell .flex_block_sell .right_block_sell {
  width: 418px;
  padding: 14px 7px;
  position: relative;
  transition: all 0.3s ease;
}

section.how_to_sell .flex_block_sell .right_block_sell.active_fixed {
  visibility: visible;
}

section.how_to_sell .flex_block_sell .right_block_sell .text_block {
  position: sticky;
  top: 170px;
  text-align: center;
  padding: 34px 47px 31px;
  border-radius: 2px;
  border: 1px solid rgba(189, 189, 189, 0.6);
}

section.how_to_sell .flex_block_sell .right_block_sell .text_block svg {
  display: inline-block;
}

section.how_to_sell .flex_block_sell .right_block_sell .text_block p {
  font-size: 16px;
  letter-spacing: .11px;
  line-height: 22px;
  margin-top: 24px;
}

section.how_to_sell .flex_block_sell .right_block_sell .text_block p strong {
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
}

.action-button {
  margin-top: 34px;
}

@media only screen and (max-width: 1024px) {
  section.how_to_sell {
    padding: 60px 0 79px;
  }

  section.how_to_sell .flex_block_sell {
    display: block;
    margin-top: 39px;
  }

  section.how_to_sell .flex_block_sell .left_block_sell {
    width: 100%;
    max-width: 100%;
  }

  section.how_to_sell .flex_block_sell .right_block_sell {
    top: 0;
    width: 100%;
    margin-top: 69px;
    box-sizing: border-box;
    padding: 0 63px;
  }

  section.how_to_sell .flex_block_sell .right_block_sell .text_block p {
    max-width: 320px;
    margin: 24px auto 0;
  }
}

@media only screen and (max-width: 767px) {
  section.how_to_sell {
    padding: 41px 0 38px;
  }

  section.how_to_sell .flex_block_sell {
    margin-top: 34px;
  }

  section.how_to_sell .flex_block_sell .left_block_sell .info_all_block ul li {
    padding: 1px 5px 27px 35px;
  }

  section.how_to_sell .flex_block_sell .left_block_sell .info_all_block ul li .name_block {
    font-size: 14px;
    line-height: 18px;
  }

  section.how_to_sell .flex_block_sell .left_block_sell .info_all_block ul li p {
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 17px;
  }

  section.how_to_sell .flex_block_sell .right_block_sell {
    padding: 0px;
    margin-top: 39px;
  }

  section.how_to_sell .flex_block_sell .right_block_sell .text_block {
    padding: 34px 20px 31px;
  }

  section.how_to_sell .flex_block_sell .right_block_sell .text_block p {
    max-width: 100%;
    margin-top: 29px;
    font-size: 14px;
    line-height: 20px;
  }

  .action-button {
    margin-top: 19px;
  }
}
</style>
